export enum FinancingRequestStudentDataTrackerName {
  StudentsData = "StudentsData"
}

export default FinancingRequestStudentDataTrackerName;
